var BASE_EMAIL_TEMPLATE_KEY = 'emailTemplate';
var emailTemplateKeys = {
  allEmailTemplates: [BASE_EMAIL_TEMPLATE_KEY],
  singleEmailTemplate: function singleEmailTemplate(emailTemplate, locale) {
    return [BASE_EMAIL_TEMPLATE_KEY, emailTemplate, locale];
  }
};
export default emailTemplateKeys;